/* eslint-disable max-len */
import React, { useState, useEffect, Fragment, useRef } from 'react'
import { translate } from 'react-translate'
import { servicesByFocusNoBranches as servicesByFocus, validSeleccion } from '../commons/constants'
import ContactForm from '../commons/ContactForm/ContactForm.component'
import { MainBanner } from '../commons/MainBanner/MainBanner.component'
import { MultiButtonSelector } from '../commons/SearchBar/components/MultiButtonSelector/MultButtonSelector.component'
import { PurposeSelector } from '../commons/SearchBar/components/PurposeSelector/PurposeSelector.component'
import { purposeSelectorOptions } from '../commons/SearchBar/components/PurposeSelector/PurposeSelector.constants'

const getRequestParams = () => {
  if (!window.location.search && window.location.search.indexOf('?') !== 0 ) return {}
  return window.location.search.slice(1).split('&').reduce((acu, item) => {
    const arr = item.split('=')
    acu[arr[0]] = arr[1]
    return acu
  }, {})
}

import './PageServices.scss'
import { AccordionList } from '../commons/AccordionList/AccordionList.component'


export const PageServices = translate('PageServices')(function Component({
  t,
  services,
  getServices,
}){

  useEffect(() => {
    getServices()
  }, [])

  const { seleccion, sector, index } = getRequestParams()
  const [option, setOption] = useState(() => validSeleccion.includes(seleccion) ? purposeSelectorOptions[seleccion] : purposeSelectorOptions.residencial)
  const [currentSector, setCurrentSector] = useState(() =>
    sector ? parseInt(sector) : servicesByFocus[0].sectorId)
  const [currentServicesOptions, setCurrentServicesOptions] = useState([])
  const [scrollTo, setScrollTo] = useState()

  const servicesRef = useRef()

  const servicesMainTexts = {
    [purposeSelectorOptions.residencial]: {
      title: t('services_residential_title'),
      text: t('services_residential_text'),
    },
    [purposeSelectorOptions.comercial]: {
      title: t('services_comercial_title'),
      text: t('services_comercial_text'),
    }
  }

  useEffect(() => {
    if(scrollTo) {
      servicesRef.current.scrollIntoView({behavior: 'smooth'})
      setScrollTo(false)
    }

  }, [scrollTo])

  useEffect(() => {
    const servicesCopy = services.length ? services.slice(2) : []
    setCurrentServicesOptions(() => (servicesCopy
      .map((item, idx) => {
        const active = (index && (index - 2 === idx))
        return ({
          ...item,
          active,
        })
      })
      .filter(item => item.sectorId === currentSector)
    ))
  }, [currentSector, services])

  const selectionPurposeOption = (value) => {
    if (value !== option) {
      setOption(value)
      const newOptions = servicesByFocus.find((opt) => opt[`${value}Focus`])
      setCurrentSector(newOptions.sectorId)
    }
  }

  const handleServiceSelection = (sectorId) => {
    setCurrentSector(sectorId)
    setScrollTo(true)
  }

  const serctorOptions = servicesByFocus
    .filter((teamOption) => {
      return teamOption[`${option}Focus`]})
    .map(service => ({
      key: service.sectorId,
      name: t(service.translationKey),
    }))

  const servicesSelector = <Fragment>
    <PurposeSelector
      onSelectOption={selectionPurposeOption}
      value={option}
      border
      />
    <MultiButtonSelector
      options={serctorOptions}
      value={currentSector}
      onClickOption={handleServiceSelection}
      />
  </Fragment>

  return <div className='page-services'>
    <MainBanner
      className='page-consultancy-main-banner'
      backgroundURL={'/assets/images/consultoria-research-bg.jpeg'}
      mainTitle={t('main_title')}
    >
      <div className='services-list-controls-container visible-xs'>
        {servicesSelector}
      </div>
    </MainBanner>
    <div className='services-list'>
      <div className='services-list-controls-container hidden-xs'>
        <h2>{t('title')}</h2>
        {servicesSelector}
      </div>
      <div className='ljr-bg-grey'>
        <div className='text-banner-1' ref={servicesRef}>
          <h2>{servicesMainTexts[option].title}</h2>
          <p>
          {servicesMainTexts[option].text}
          </p>
        </div>
      </div>
      <div className={'services-options'}>
        <AccordionList elements={currentServicesOptions} />
      </div>
    </div>

    <div className='form-container'>
      <ContactForm hideButtonBranches={true}/>
    </div>
  </div>
})


// WEBPACK FOOTER //
// ./src/features/PageServices/PageServices.component.js